export class User {
  groupNames: Array<string> = [];

  id: number;
  intranet_id: number;
  login: string;
  person_id: number;
  created_at: any;
  updated_at: any;
  email: string;
  attorney_number: number;
  is_active: boolean = true;
  parent_id: number;
  time_zone: string;
  matter_id: number;
  chart_of_account_id: number;
  hourly_rate: number;
  hours: number;
  start_date: any;
  dependants: number;
  is_married: boolean = false;
  pension_percent: number;
  life_cost: number;
  factor_percent: number;
  terminated_on: any;
  termination_reason_id: number;
  rehired_on: any;
  notes: string;
  health_premium_per_pay: number;
  health_savings: number;
  health_flex: number;
  admittance_date: any;
  health_premium_per_month: number;
  health_cost_per_pay: number;
  health_cost_per_month: number;
  color_code: string;
  number_of_histories: number;
  matter_history_type_id: number;
  default_calendar_view: string;
  default_calendar_agenda: string;
  event_age: string;
  number_of_entries: number;
  entry_age: string;
  show_billing_summary: boolean = true;
  history_age: string;
  event_days: number;
  to_do_visibility: boolean = true;
  eit: number;
  personnel_id: number;
  avvo_url: string;
  number_of_favorites: number;
  number_of_recents: number;
  password: string;
  password_confirmation: string;
  is_other_comp: boolean = false;
  roth_ira_percent: number;
  group_ids: Array<number> = [];
  api_key: string;
  of_counsel: boolean;
  include_in_letterhead: boolean;
  letter_head_position: number;
  is_attorney: boolean;
  allow_phone_text: boolean = false;
  receive_document_notifications_by_email: boolean = true;
  extension: number;
  latitude: number;
  longitude: number;
  otp_email: string;
  otp_phone: string;
  otp_source: string;
  opt_use_contact_info: boolean;

  constructor(values: any = {}) {
    if (values.groupNames) this.groupNames = values.groupNames;
    this.id = values.id;
    this.intranet_id = values.intranet_id;
  }

  inGroup(groupNames: Array<string>): boolean {
    for (let groupName of groupNames) if (this.groupNames.indexOf(groupName) > -1) return true;
    return false;
  }

  is(grouped: string): boolean {
    let groupedSplit: Array<string> = grouped.split(' ');
    for (let groupedStr of groupedSplit)
      switch (groupedStr) {
        case 'accountant':
          if (this.isAccountant()) return true;
          else break;
        case 'admin':
          if (this.isAdmin()) return true;
          else break;
        case 'attorney':
          if (this.isAttorney()) return true;
          else break;
        case 'editor':
          if (this.isEditor()) return true;
          else break;
        case 'intake':
          if (this.isIntake()) return true;
          else break;
        case 'manager':
          if (this.isManager()) return true;
          else break;
        case 'owner':
          if (this.isOwner()) return true;
          else break;
        case 'president':
          if (this.isPresident()) return true;
          else break;
        case 'priviledged':
          if (this.isPriviledged()) return true;
          else break;
        case 'reportable':
          if (this.isReportable()) return true;
          else break;
        case 'staff':
          if (this.isStaff()) return true;
          else break;
        case 'superuser':
          if (this.isSuperuser()) return true;
          else break;
        case 'suspended':
          if (this.isSuspended()) return true;
          else break;
        case 'tech':
          if (this.isTech()) return true;
          else break;
      }
    return false;
  }

  isAccountant(): boolean {
    return this.inGroup(['accounting']);
  }

  isAdmin(): boolean {
    return this.inGroup(['admin']);
  }

  isAttorney(): boolean {
    return this.inGroup(['attorney']);
  }

  isEditor(): boolean {
    return this.inGroup(['Editors', 'editors', 'owner', 'admin', 'tech']);
  }

  isIntake(): boolean {
    return this.inGroup(['intake']);
  }

  isManager(): boolean {
    return this.inGroup(['accounting', 'admin', 'management', 'payroll']);
  }

  isOwner(): boolean {
    return this.inGroup(['owners']);
  }

  isPresident(): boolean {
    return this.inGroup(['president']);
  }

  isPriviledged(): boolean {
    return this.inGroup(['personnel', 'admin', 'management', 'owner']);
  }

  isReportable(): boolean {
    return this.inGroup(['reportable']);
  }

  isStaff(): boolean {
    return this.inGroup(['staff']);
  }

  isSuperuser(): boolean {
    return this.inGroup(['superuser']);
  }

  isSuspended(): boolean {
    return this.inGroup(['suspended']);
  }

  isTech(): boolean {
    return this.inGroup(['tech']);
  }
}
